class PlayerSession {
  constructor(player, option) {
    this.startTime = null;
    this._tickStart = null;
    this.totalPlayTime = 0;
    this.totalToday = 0;
    this.timer = null;
    this.started = false;
    this.sessionId = null;
    this._player = player;
    this._options = option;
    // One-shot latch: _send runs every tick and on every visibility change, so
    // without this the portal would re-open the daily-limit modal each minute.
    this._timeplayExceeded = false;
  }

  async _send(type) {
    const now = Date.now();
    const sessionDuration = now - (this._tickStart ?? now);
    const secondsThisTick = Math.floor(sessionDuration / 1000);
    const totalSeconds = this.totalPlayTime + secondsThisTick;

    const payload = {
      type,
      startTime: this.startTime,
      lastUpdated: now,
      totalPlayTime: totalSeconds,
      sessionId: this.sessionId,
    };

    try {
      let url = `${this._options.apiDomain}/player-session`;
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Player-Token': this._player.token,
          'Game-Key': this._options.gameId,
        },
        body: JSON.stringify(payload),
      });
      const response = await res.json();
      if (type === 'start') {
        this.sessionId = response.data.sessionId;
        console.log(`Session started. ID: ${this.sessionId}`);
      }

      this.totalToday = response.data.todayTotalPlayTime;
      // Check maxTimeplay only if it's not null
      if (
        this._options.maxTimeplay !== null &&
        this.totalToday >= this._options.maxTimeplay &&
        !this._timeplayExceeded
      ) {
        this._timeplayExceeded = true;
        this.callPopup('AlertTimeplay');
      }

      this.totalPlayTime = totalSeconds;
      this.lastUpdated = now;
      this._tickStart = now;
    } catch (err) {
      console.error(`Failed to ${type} session:`, err);
    }
  }

  async start() {
    if (!this.sessionId) {
      this.startTime = Date.now();
      this.lastUpdated = this.startTime;
      this._tickStart = this.startTime;
      this.totalPlayTime = 0;
      await this._send('start');
    }

    if (!this.started) {
      this._tickStart = Date.now();
      this.timer = setInterval(
        () => this._send('update'),
        this._options.intervalPlayerSession * 1000,
      );
      this.started = true;
      console.log('Session tracking resumed.');
    }

    this.registerVisibilityChange();
  }

  async stop() {
    if (!this.started) return;

    clearInterval(this.timer);
    this.timer = null;
    this.started = false;

    await this._send('update');
    console.log(`Paused session at ${this.totalPlayTime}s`);
  }

  registerVisibilityChange() {
    if (this.onVisibilityChange) {
      this.unregisterVisibilityChange();
    }
    this.onVisibilityChange = (event) => {
      console.log(
        `Visibility triggered by: ${event.type}, hidden state: ${document.hidden}`,
        event,
      );
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };

    document.addEventListener('visibilitychange', this.onVisibilityChange);
    window.addEventListener('blur', this.onVisibilityChange);
    window.addEventListener('focus', this.onVisibilityChange);
  }

  unregisterVisibilityChange() {
    if (!this.onVisibilityChange) return;
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    window.removeEventListener('blur', this.onVisibilityChange);
    window.removeEventListener('focus', this.onVisibilityChange);
    this.onVisibilityChange = null;
  }

  async destroy() {
    await this.stop();
    this.unregisterVisibilityChange();
    console.log('Session destroyed.');
  }

  callPopup(type) {
    window.parent.postMessage(type, '*');
  }
}

export default PlayerSession;
